import { Box, Typography, Stack } from '@mui/material';
import { Icon } from '@iconify/react';

const InfoCard = ({
  icon,
  title,
  content,
  sx = {}
}: {
  icon?: string;
  title: string;
  content: string;
  sx?: object;
}) => {
  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        boxShadow: 2,
        backgroundColor: 'action.hover',
        ...sx
      }}
    >
      <Stack direction="row" alignItems="center" spacing={2}>
        {icon && (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Icon icon={icon} fontSize="32px" />
          </Box>
        )}

        {/* Title and Content */}
        <Stack direction="column" spacing={0.5} justifyContent="center" flexGrow={1}>
          <Typography variant="body2" color="text.secondary" fontWeight="bold">
            {title}
          </Typography>
          <Typography variant="body1">{content || 'N/A'}</Typography>
        </Stack>
      </Stack>
    </Box>
  );
};

export default InfoCard;
